<template>
  <div class="order-notice so-file-change-notice">
    <div class="notice-hero">
      <div class="hero-icon hero-icon--info">
        <i class="el-icon-document" />
      </div>
      <div class="hero-title">{{ payload.title || 'SO文件已更换' }}</div>
      <div class="hero-desc">以下订单的 SO(PDF) 已被更换</div>
    </div>

    <div v-if="lineItems.length" class="change-list">
      <div v-for="(item, idx) in lineItems" :key="idx" class="change-row">
        <span class="order-no">{{ item.orderNo || '—' }}</span>
        <span class="container-type">{{ item.containerType || '—' }}</span>
        <span class="change-msg">{{ item.message || '文件被更换' }}</span>
      </div>
    </div>
    <div v-else-if="payload.content" class="plain-content">{{ payload.content }}</div>

    <div class="notice-actions">
      <el-button type="primary" @click="$emit('read')">已读</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SoFileChangeNotice',
  props: {
    payload: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    lineItems() {
      return Array.isArray(this.payload.items) ? this.payload.items : []
    }
  }
}
</script>

<style scoped>
.order-notice {
  padding: 4px 4px 0;
}
.notice-hero {
  text-align: center;
  margin-bottom: 16px;
}
.hero-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 14px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
}
.hero-icon--info {
  background: #edf5ff;
  color: #409eff;
}
.hero-title {
  font-size: 18px;
  font-weight: 700;
  color: #1f2329;
  margin-bottom: 8px;
  line-height: 1.4;
}
.hero-desc {
  font-size: 13px;
  color: #8f959e;
  line-height: 1.6;
}
.change-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px;
  background: #f7f8fa;
  border: 1px solid #eef0f3;
  border-radius: 10px;
}
.change-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  line-height: 1.5;
}
.order-no {
  font-weight: 700;
  color: #1f2329;
}
.container-type {
  color: #3370ff;
  font-weight: 600;
}
.change-msg {
  color: #646a73;
}
.plain-content {
  white-space: pre-line;
  font-size: 14px;
  line-height: 1.6;
  color: #1f2329;
  padding: 12px 14px;
  background: #f7f8fa;
  border-radius: 10px;
}
.notice-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
}
</style>
